// Секция «Дата»: обратный отсчёт до торжества. Целевую дату берём из
// data-countdown (ISO со смещением зоны), числа обновляем раз в секунду.
// Русские подписи склоняем по числу; киргизские не склоняются (после
// числительного — всегда одна форма).

const RU_FORMS = {
	days: ["день", "дня", "дней"],
	hours: ["час", "часа", "часов"],
	minutes: ["минута", "минуты", "минут"],
	seconds: ["секунда", "секунды", "секунд"],
};

// Русское склонение: 1 день / 2 дня / 5 дней (11–14 — всегда «дней»)
function pluralRu(n, forms) {
	const mod100 = n % 100;
	if (mod100 >= 11 && mod100 <= 14) return forms[2];
	const mod10 = n % 10;
	if (mod10 === 1) return forms[0];
	if (mod10 >= 2 && mod10 <= 4) return forms[1];
	return forms[2];
}

function pad2(n) {
	return String(n).padStart(2, "0");
}

function setupGrid(grid) {
	const target = new Date(grid.getAttribute("data-countdown")).getTime();
	if (Number.isNaN(target)) return;

	const countdown = grid.closest(".countdown");
	const nums = {
		days: grid.querySelector('[data-cd="days"]'),
		hours: grid.querySelector('[data-cd="hours"]'),
		minutes: grid.querySelector('[data-cd="minutes"]'),
		seconds: grid.querySelector('[data-cd="seconds"]'),
	};
	const labelsRu = {
		days: grid.querySelector('[data-cd-label="days"]'),
		hours: grid.querySelector('[data-cd-label="hours"]'),
		minutes: grid.querySelector('[data-cd-label="minutes"]'),
		seconds: grid.querySelector('[data-cd-label="seconds"]'),
	};

	let timerId;

	function tick() {
		const diff = Math.max(0, target - Date.now());
		const totalSec = Math.floor(diff / 1000);

		const values = {
			days: Math.floor(totalSec / 86400),
			hours: Math.floor((totalSec % 86400) / 3600),
			minutes: Math.floor((totalSec % 3600) / 60),
			seconds: totalSec % 60,
		};

		for (const key in nums) {
			// дни без ведущего нуля (может быть 2–3 цифры), остальное — по два знака
			if (nums[key]) nums[key].textContent = key === "days" ? String(values[key]) : pad2(values[key]);
			if (labelsRu[key]) labelsRu[key].textContent = pluralRu(values[key], RU_FORMS[key]);
		}

		if (diff === 0) {
			clearInterval(timerId);
			if (countdown) countdown.classList.add("is-done");
		}
	}

	tick();
	timerId = setInterval(tick, 1000);
}

export function initCountdown() {
	document.querySelectorAll("[data-countdown]").forEach(setupGrid);
}
